import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'

// Ordering Management
import OrderingManagement from 'src/components/Dashboard/Views/OrderingManagement/OrderingManagement.vue'

// Customers
import CustomersView from 'src/components/Dashboard/Views/Customers/CustomersView.vue'
// import CustomersSidebar from 'src/components/Dashboard/Views/Customers/CustomerSidebar.vue'
import Customers from 'src/components/Dashboard/Views/Customers/Customers.vue'
import CustomerView from 'src/components/Dashboard/Views/Customers/CustomerView.vue'
import GroupsCustomer from 'src/components/Dashboard/Views/Customers/Groups/Groups.vue'
import GroupsCustomerView from 'src/components/Dashboard/Views/Customers/Groups/GroupView.vue'
import Approvals from 'src/components/Dashboard/Views/Customers/Approvals/Approvals.vue'

import ScreenView from 'src/components/Dashboard/Views/Screens/ScreenView.vue'

// ODS Order Display Screen
import OrderScreenView from 'src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenView.vue'
import OrderScreenTabs from 'src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenTabs.vue'

// KDS Kitchen Display Screen
import KdsSidebar from 'src/components/Dashboard/Views/Screens/Kds/KdsSidebar.vue'
import Kds from 'src/components/Dashboard/Views/Screens/Kds/Kds.vue'
import KdsAdd from 'src/components/Dashboard/Views/Screens/Kds/KdsAdd.vue'
import KdsEdit from 'src/components/Dashboard/Views/Screens/Kds/KdsEdit.vue'
import KdsReport from 'src/components/Dashboard/Views/Screens/Kds/KdsReport.vue'
import KdsSettingsUsers from 'src/components/Dashboard/Views/Screens/Kds/KdsSettingsUsers.vue'
import KdsUserAdd from 'src/components/Dashboard/Views/Screens/Kds/Users/KdsUserAdd.vue'
import KdsUserEdit from 'src/components/Dashboard/Views/Screens/Kds/Users/KdsUserEdit.vue'

// KDS Sections
import KdsSections from 'src/components/Dashboard/Views/Screens/Kds/Sections/KdsSections.vue'
import KdsSectionAdd from 'src/components/Dashboard/Views/Screens/Kds/Sections/KdsSectionAdd.vue'
import KdsSectionEdit from 'src/components/Dashboard/Views/Screens/Kds/Sections/KdsSectionEdit.vue'
import KdsSettings from 'src/components/Dashboard/Views/Screens/Kds/KdsSettings.vue'

// CDS Client Display Screen
import OrderScreen from 'src/components/Dashboard/Views/Screens/OrderScreen/OrderScreen.vue'
import OrderScreenAdd from 'src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenAdd.vue'
import OrderScreenEdit from 'src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenEdit.vue'

import PosScreenAdd from 'src/components/Dashboard/Views/Screens/PosScreen/PosScreenAdd.vue'
import PosScreenEdit from 'src/components/Dashboard/Views/Screens/PosScreen/PosScreenEdit.vue'

import DigitalSignageAdd from 'src/components/Dashboard/Views/Screens/DigitalSignage/DigitalSignageAdd.vue'
import DigitalSignageEdit from 'src/components/Dashboard/Views/Screens/DigitalSignage/DigitalSignageEdit.vue'


import GiftCardForm from 'src/components/Dashboard/Views/Marketing/GiftCard/GiftCardForm.vue'


// Management
import ManagementTabs from 'src/components/Dashboard/Views/Management/ManagementTabs.vue'
import ManagementOutputsTabs from 'src/components/Dashboard/Views/Management/ManagementOutputsTabs.vue'
import ManagementEntriesTabs from 'src/components/Dashboard/Views/Management/ManagementEntriesTabs.vue'
import ManagementStocksTabs from 'src/components/Dashboard/Views/Management/ManagementStocksTabs.vue'
import ManagementSidebar from 'src/components/Dashboard/Views/Management/ManagementSidebar.vue'
import ManagementDashboard from 'src/components/Dashboard/Views/Management/Dashboard/ManagementDashboard.vue'

import NomenclatorTabs from 'src/components/Dashboard/Views/Management/Nomenclator/NomenclatorTabs.vue'
import NomenclatorProducts from 'src/components/Dashboard/Views/Management/Nomenclator/NomenclatorProducts.vue'
import NomenclatorProductsEdit from 'src/components/Dashboard/Views/Management/Nomenclator/NomenclatorProductsEdit.vue'
import ManagementClients from 'src/components/Dashboard/Views/Management/Nomenclator/ManagementClients.vue'

import ManagementStocks from 'src/components/Dashboard/Views/Management/Stocks/ManagementStocks.vue'
import ManagementStocksAdd from 'src/components/Dashboard/Views/Management/Stocks/ManagementStocksAdd.vue'
import ManagementStocksEdit from 'src/components/Dashboard/Views/Management/Stocks/ManagementStocksEdit.vue'

import ManagementProduction from 'src/components/Dashboard/Views/Management/ManagementProduction.vue'
import ManagementLot from 'src/components/Dashboard/Views/Management/ManagementLot.vue'

import ManagementBonProduct from 'src/components/Dashboard/Views/Management/Nomenclator/ManagementBonProduct.vue'
import ManagementBonProductAdd from 'src/components/Dashboard/Views/Management/Nomenclator/ManagementBonProductAdd.vue'
import ManagementBonProductEdit from 'src/components/Dashboard/Views/Management/Nomenclator/ManagementBonProductEdit.vue'

import ManagementTransfer from 'src/components/Dashboard/Views/Management/Transfer/ManagementTransfer.vue'
import ManagementTransferAdd from 'src/components/Dashboard/Views/Management/Transfer/ManagementTransferAdd.vue'
import ManagementTransferEdit from 'src/components/Dashboard/Views/Management/Transfer/ManagementTransferEdit.vue'

import ManagementAviz from 'src/components/Dashboard/Views/Management/Outputs/ManagementAviz.vue'
import ManagementAvizAdd from 'src/components/Dashboard/Views/Management/Outputs/ManagementAvizAdd.vue'
import ManagementAvizEdit from 'src/components/Dashboard/Views/Management/Outputs/ManagementAvizEdit.vue'
import ManagementBonFiscal from 'src/components/Dashboard/Views/Management/Outputs/ManagementBonFiscal.vue'
import ManagementBonFiscalView from 'src/components/Dashboard/Views/Management/Outputs/ManagementBonFiscalView.vue'

import ManagementEntries from 'src/components/Dashboard/Views/Management/Entries/ManagementEntries.vue'
import ManagementEntriesAdd from 'src/components/Dashboard/Views/Management/Entries/ManagementEntriesAdd.vue'
import ManagementEntriesEdit from 'src/components/Dashboard/Views/Management/Entries/ManagementEntriesEdit.vue'

import ManagementInvoiceSupplier from 'src/components/Dashboard/Views/Management/Entries/ManagementInvoiceSupplier.vue'
import ManagementInvoiceSupplierView from 'src/components/Dashboard/Views/Management/Entries/ManagementInvoiceSupplierView.vue'

import ManagementInventory from 'src/components/Dashboard/Views/Management/Inventory/ManagementInventory.vue'
import ManagementInventoryAdd from 'src/components/Dashboard/Views/Management/Inventory/ManagementInventoryAdd.vue'
import ManagementInventoryEdit from 'src/components/Dashboard/Views/Management/Inventory/ManagementInventoryEdit.vue'

import ManagementInitialStock from 'src/components/Dashboard/Views/Management/InitialStock/ManagementInitialStock.vue'
import ManagementInitialStockAdd from 'src/components/Dashboard/Views/Management/InitialStock/ManagementInitialStockAdd.vue'
import ManagementInitialStockEdit from 'src/components/Dashboard/Views/Management/InitialStock/ManagementInitialStockEdit.vue'

import ManagementWasted from 'src/components/Dashboard/Views/Management/Wasted/ManagementWasted.vue'
import ManagementWastedAdd from 'src/components/Dashboard/Views/Management/Wasted/ManagementWastedAdd.vue'
import ManagementWastedEdit from 'src/components/Dashboard/Views/Management/Wasted/ManagementWastedEdit.vue'

import ManagementSuppliersTabs from 'src/components/Dashboard/Views/Management/Suppliers/ManagementSuppliersTabs.vue'
import ManagementSuppliers from 'src/components/Dashboard/Views/Management/Suppliers/ManagementSuppliers.vue'
import ManagementOrdersSuppliers from 'src/components/Dashboard/Views/Management/Suppliers/ManagementOrdersSuppliers.vue'
import ManagementMyOrdersSuppliers from 'src/components/Dashboard/Views/Management/Suppliers/ManagementMyOrdersSuppliers.vue'
import ManagementMyOrdersSuppliersAdd from 'src/components/Dashboard/Views/Management/Suppliers/ManagementMyOrdersSuppliersAdd.vue'
import ManagementMyOrdersSuppliersEdit from 'src/components/Dashboard/Views/Management/Suppliers/ManagementMyOrdersSuppliersEdit.vue'
import ManagementForOrdersSuppliers from 'src/components/Dashboard/Views/Management/Suppliers/ManagementForOrdersSuppliers.vue'
import ManagementForOrdersSuppliersAdd from 'src/components/Dashboard/Views/Management/Suppliers/ManagementForOrdersSuppliersAdd.vue'
import ManagementForOrdersSuppliersEdit from 'src/components/Dashboard/Views/Management/Suppliers/ManagementForOrdersSuppliersEdit.vue'

// Accounting
import AccountingInboundInvoices from 'src/components/Dashboard/Views/Management/Accounting/AccountingInboundInvoices.vue'
import AccountingSales from 'src/components/Dashboard/Views/Management/Accounting/AccountingSales.vue'

import ManagementCasaRegister from 'src/components/Dashboard/Views/Management/Casa/ManagementCasaRegister.vue'

import ManagementReports from 'src/components/Dashboard/Views/Management/ManagementReports.vue'

import ManagementSettings from 'src/components/Dashboard/Views/Management/ManagementSettings.vue'
import ManagementUsers from 'src/components/Dashboard/Views/Management/ManagementUsers.vue'

// Invoice
import InvoiceTabs from 'src/components/Dashboard/Views/Invoice/InvoiceTabs.vue'

import InvoiceSidebar from 'src/components/Dashboard/Views/Invoice/InvoiceSidebar.vue'
import InvoiceDashboard from 'src/components/Dashboard/Views/Invoice/InvoiceDashboard.vue'
import InvoiceAdd from 'src/components/Dashboard/Views/Invoice/InvoiceAdd.vue'
import InvoiceStorno from 'src/components/Dashboard/Views/Invoice/InvoiceStorno.vue'
import InvoiceEdit from 'src/components/Dashboard/Views/Invoice/InvoiceEdit.vue'

import InvoiceSettings from 'src/components/Dashboard/Views/Invoice/InvoiceSettings.vue'
import InvoiceReports from 'src/components/Dashboard/Views/Invoice/InvoiceReports.vue'

// Proforma
import Proforma from 'src/components/Dashboard/Views/Invoice/Proforma/Proforma.vue'
import ProformaAdd from 'src/components/Dashboard/Views/Invoice/Proforma/ProformaAdd.vue'
import ProformaEdit from 'src/components/Dashboard/Views/Invoice/Proforma/ProformaEdit.vue'

// Catalog
// import CatalogView from 'src/components/Dashboard/Views/Catalog/CatalogView.vue'

// InfoPages
import InfoPages from 'src/components/Dashboard/Views/InfoPages/InfoPages.vue'

// CustomInfoPages
import CustomInfoPages from 'src/components/Dashboard/Views/InfoPagesCustom/CustomInfoPages.vue'
import CustomInfoPageAdd from 'src/components/Dashboard/Views/InfoPagesCustom/CustomInfoPageAdd.vue'
import CustomInfoPageEdit from 'src/components/Dashboard/Views/InfoPagesCustom/CustomInfoPageEdit.vue'

// Reservations
import Reservations from 'src/components/Dashboard/Views/Reservations/Reservations.vue'

// Tables
import Tables from 'src/components/Dashboard/Views/Tables/Tables.vue'

// Orders
import Orders from 'src/components/Dashboard/Views/Orders/Orders.vue'
import OrderView from 'src/components/Dashboard/Views/Orders/OrderView.vue'
import OrderEdit from 'src/components/Dashboard/Views/Orders/OrderEdit.vue'

// Loyalty Points Scanner
import Scanner from 'src/components/Dashboard/Views/LoyaltyPointsScanner/LoyaltyPointsScanner.vue'

// Add OrdersPos
import OrdersPos from 'src/components/Dashboard/Views/OrdersPos/OrdersPos.vue'
import OrdersPosView from 'src/components/Dashboard/Views/OrdersPos/OrdersPosView.vue'
import OrderPosClientScreen from 'src/components/Dashboard/Views/OrdersPos/OrderPosClientScreen.vue'

// Add PosSettings
import PosSettingsView from 'src/components/Dashboard/Views/PosSettings/PosView.vue'
import PosSettingsTabs from 'src/components/Dashboard/Views/PosSettings/PosTabs.vue'
import PosSettingsList from 'src/components/Dashboard/Views/PosSettings/PosList.vue'
import PosSettingsUsers from 'src/components/Dashboard/Views/PosSettings/PosSettingsUsers.vue'
import PosSettingsSettings from 'src/components/Dashboard/Views/PosSettings/PosSettingsSettings.vue'
import PosSettingsReports from 'src/components/Dashboard/Views/PosSettings/PosSettingsReports.vue'

import PosSettingsAdd from 'src/components/Dashboard/Views/PosSettings/pos/PosAdd.vue'
import PosSettingsEdit from 'src/components/Dashboard/Views/PosSettings/pos/PosEdit.vue'
// import PosSettingsForm from 'src/components/Dashboard/Views/PosSettings/pos/PosForm.vue'

import PosUserAdd from 'src/components/Dashboard/Views/PosSettings/users/PosUserAdd.vue'
import PosUserEdit from 'src/components/Dashboard/Views/PosSettings/users/PosUserEdit.vue'
// import PosUserForm from 'src/components/Dashboard/Views/PosSettings/users/PosUserForm.vue'

import PosMapAdd from 'src/components/Dashboard/Views/PosSettings/maps/PosMapAdd.vue'
import PosMapEdit from 'src/components/Dashboard/Views/PosSettings/maps/PosMapEdit.vue'
// import PosMapForm from 'src/components/Dashboard/Views/PosSettings/maps/PosMapForm.vue'

import FiscalPrinterAdd from 'src/components/Dashboard/Views/PosSettings/fiscalPrinter/FiscalPrinterAdd.vue'
import FiscalPrinterEdit from 'src/components/Dashboard/Views/PosSettings/fiscalPrinter/FiscalPrinterEdit.vue'

import CantarAdd from 'src/components/Dashboard/Views/PosSettings/cantar/CantarAdd.vue'
import CantarEdit from 'src/components/Dashboard/Views/PosSettings/cantar/CantarEdit.vue'

// Add Dispatch
import Dispatch from 'src/components/Dashboard/Views/Dispatch/Dispatch.vue'
import DispatchTabs from 'src/components/Dashboard/Views/Dispatch/DispatchTabs.vue'
import DispatchOrders from 'src/components/Dashboard/Views/Dispatch/DispatchView.vue'
import DispatchDrivers from 'src/components/Dashboard/Views/Dispatch/DispatchDrivers.vue'
import DispatchReports from 'src/components/Dashboard/Views/Dispatch/DispatchReports.vue'
import DispatchSettings from 'src/components/Dashboard/Views/Dispatch/DispatchSettings.vue'

// Online
import Online from 'src/components/Dashboard/Views/Online/Online.vue'

// Kiosk
import Kiosk from 'src/components/Dashboard/Views/Kiosk/Kiosk.vue'

// Qr
import Qr from 'src/components/Dashboard/Views/Qr/Qr.vue'

// Products
import CatalogSidebar from 'src/components/Dashboard/Views/Catalog/CatalogSidebar.vue'
// import Products from 'src/components/Dashboard/Views/Products/Products.vue'
import ProductsList from 'src/components/Dashboard/Views/Products/ProductsList.vue'
import ProductAdd from 'src/components/Dashboard/Views/Products/ProductAdd.vue'
import ProductEdit from 'src/components/Dashboard/Views/Products/ProductEdit.vue'

// PriceProfile
import PriceProfile from 'src/components/Dashboard/Views/Products/PriceProfile.vue'
import PriceProfileAdd from 'src/components/Dashboard/Views/Products/PriceProfileAdd.vue'
import PriceProfileEdit from 'src/components/Dashboard/Views/Products/PriceProfileEdit.vue'

// Product Options
import ProductOptions from 'src/components/Dashboard/Views/Settings/Tabs/ProductOptions.vue'
import ProductOptions2 from 'src/components/Dashboard/Views/ProductOptions/ProductOptions.vue'
import ProductOptionAdd from 'src/components/Dashboard/Views/ProductOptions/ProductOptionsAdd.vue'
import ProductOptionEdit from 'src/components/Dashboard/Views/ProductOptions/ProductOptionsEdit.vue'

// Group Options
import GroupOptions from 'src/components/Dashboard/Views/GroupOptions/GroupOptions.vue'
import GroupOptionsAdd from 'src/components/Dashboard/Views/GroupOptions/GroupOptionsAdd.vue'
import GroupOptionsEdit from 'src/components/Dashboard/Views/GroupOptions/GroupOptionsEdit.vue'
import IntegrationMenuEntityEditPage from 'src/components/Dashboard/Views/Integrations/IntegrationMenuEntityEditPage.vue'

// Product Filters
import ProductFilters from 'src/components/Dashboard/Views/Settings/Tabs/ProductFilters.vue'

// Categories
import Categories from 'src/components/Dashboard/Views/Categories/Categories.vue'
import CategoryAdd from 'src/components/Dashboard/Views/Categories/CategoryAdd.vue'
import CategoryEdit from 'src/components/Dashboard/Views/Categories/CategoryEdit.vue'

// Top Categories
import TopCategories from 'src/components/Dashboard/Views/TopCategories/TopCategories.vue'
import TopCategoryAdd from 'src/components/Dashboard/Views/TopCategories/TopCategoryAdd.vue'
import TopCategoryEdit from 'src/components/Dashboard/Views/TopCategories/TopCategoryEdit.vue'
// Menu Links
import MenuLinks from 'src/components/Dashboard/Views/MenuLinks/MenuLinks.vue'
import MenuLinkAdd from 'src/components/Dashboard/Views/MenuLinks/MenuLinkAdd.vue'
import MenuLinkEdit from 'src/components/Dashboard/Views/MenuLinks/MenuLinkEdit.vue'

// Marketing
// import MarketingView from 'src/components/Dashboard/Views/Marketing/MarketingView.vue'
import MarketingSidebar from 'src/components/Dashboard/Views/Marketing/MarketingSidebar.vue'
// -- campaigns
import Campaigns from 'src/components/Dashboard/Views/Marketing/Campaigns/Campaigns.vue'
import CampaignAdd from 'src/components/Dashboard/Views/Marketing/Campaigns/CampaignAdd.vue'
import CampaignEdit from 'src/components/Dashboard/Views/Marketing/Campaigns/CampaignEdit.vue'
import CouponPage from 'src/components/Dashboard/Views/Marketing/DiscountCoupons/CouponPage.vue'
import SubscriptionPage from 'src/components/Dashboard/Views/Marketing/Subscriptions/SubscriptionPage.vue'
import SubscribersPage from 'src/components/Dashboard/Views/Marketing/Subscriptions/SubscribersPage.vue'
import AutomationCampaignPage from 'src/components/Dashboard/Views/Marketing/AutomationCampaigns/AutomationCampaignPage.vue'
import AutomationBeneficiariesPage from 'src/components/Dashboard/Views/Marketing/AutomationCampaigns/AutomationBeneficiariesPage.vue'
// -- donation campaigns
import DonationCampaigns from 'src/components/Dashboard/Views/Marketing/DonationCampaigns/DonationCampaigns.vue'
import DonationCampaignAdd from 'src/components/Dashboard/Views/Marketing/DonationCampaigns/DonationCampaignAdd.vue'
import DonationCampaignEdit from 'src/components/Dashboard/Views/Marketing/DonationCampaigns/DonationCampaignEdit.vue'
// -- menu subscriptions (Abonamente meniuri)
import MenuSubscriptionPage from 'src/components/Dashboard/Views/Marketing/MenuSubscriptions/MenuSubscriptionPage.vue'
import MenuSubscribersPage from 'src/components/Dashboard/Views/Marketing/MenuSubscriptions/MenuSubscribersPage.vue'
// -- discount campaigns
import DiscountCampaigns from 'src/components/Dashboard/Views/Marketing/DiscountCampaigns/DiscountCampaigns.vue'
import DiscountCampaignAdd from 'src/components/Dashboard/Views/Marketing/DiscountCampaigns/DiscountCampaignAdd.vue'
import DiscountCampaignEdit from 'src/components/Dashboard/Views/Marketing/DiscountCampaigns/DiscountCampaignEdit.vue'
// -- challenge campaigns
import ChallengeCampaigns from 'src/components/Dashboard/Views/Marketing/ChallengeCampaigns/ChallengeCampaigns.vue'
import ChallengeCampaignAdd from 'src/components/Dashboard/Views/Marketing/ChallengeCampaigns/ChallengeCampaignAdd.vue'
import ChallengeCampaignEdit from 'src/components/Dashboard/Views/Marketing/ChallengeCampaigns/ChallengeCampaignEdit.vue'
// -- spinning wheel campaigns
import SpinningWheelCampaigns from 'src/components/Dashboard/Views/Marketing/SpinningWheel/SpinningWheelCampaigns.vue'
import SpinningWheelCampaignAdd from 'src/components/Dashboard/Views/Marketing/SpinningWheel/SpinningWheelCampaignAdd.vue'
import SpinningWheelCampaignEdit from 'src/components/Dashboard/Views/Marketing/SpinningWheel/SpinningWheelCampaignEdit.vue'
// -- offers
import Offers from 'src/components/Dashboard/Views/Marketing/Offers/Offers.vue'
import OffersEdit from 'src/components/Dashboard/Views/Marketing/Offers/OffersEdit.vue'
import OffersAdd from 'src/components/Dashboard/Views/Marketing/Offers/OffersAdd.vue'
import OffersGroupAdd from 'src/components/Dashboard/Views/Marketing/Offers/Group/GroupAdd.vue'
import OffersGroupEdit from 'src/components/Dashboard/Views/Marketing/Offers/Group/GroupEdit.vue'
// -- fidelitiess
import Fidelities from 'src/components/Dashboard/Views/Marketing/Fidelities/Fidelities.vue'
import UserLabeling from 'src/components/Dashboard/Views/Marketing/Fidelities/UserLabel/UserLabeling.vue'
import UserLabelingAdd from 'src/components/Dashboard/Views/Marketing/Fidelities/UserLabel/UserLabelingAdd.vue'
import UserLabelingEdit from 'src/components/Dashboard/Views/Marketing/Fidelities/UserLabel/UserLabelingEdit.vue'

// -- promos
import Promos from 'src/components/Dashboard/Views/Marketing/Promos/Promos.vue'
import PromosAdd from 'src/components/Dashboard/Views/Marketing/Promos/PromosAdd.vue'
import PromosEdit from 'src/components/Dashboard/Views/Marketing/Promos/PromosEdit.vue'
// -- referral program
import ReferralCampaignAdd from 'src/components/Dashboard/Views/Marketing/Referral/ReferralCampaignAdd.vue'
import ReferralCampaignEdit from 'src/components/Dashboard/Views/Marketing/Referral/ReferralCampaignEdit.vue'
// -- raffle campaigns
import RaffleCampaignAdd from 'src/components/Dashboard/Views/Marketing/RaffleCampaigns/RaffleCampaignAdd.vue'
import RaffleCampaignEdit from 'src/components/Dashboard/Views/Marketing/RaffleCampaigns/RaffleCampaignEdit.vue'
// -- loyalty store
import LoyaltyStoreCampaignAdd from 'src/components/Dashboard/Views/Marketing/LoyaltyStore/LoyaltyStoreCampaignAdd.vue'
import LoyaltyStoreCampaignEdit from 'src/components/Dashboard/Views/Marketing/LoyaltyStore/LoyaltyStoreCampaignEdit.vue'
// -- dynamic menus
import DynamicMenu from 'src/components/Dashboard/Views/Marketing/DynamicMenus/DynamicMenu.vue'

// Reward Points
import RewardProgramEdit from 'src/components/Dashboard/Views/RewardProgram/RewardProgramEdit.vue'

// Reports
import Reports from 'src/components/Dashboard/Views/Reports/Reports.vue'
import ReportsCustomerDetails from 'src/components/Dashboard/Views/Reports/ReportsCustomerDetails.vue'
import CharismaItems from 'src/components/Dashboard/Views/Reports/Versions/2/CharismaItems.vue'
import NexusItems from 'src/components/Dashboard/Views/Reports/Versions/2/NexusItems.vue'
import PosOrderActionsDetails from 'src/components/Dashboard/Views/Reports/Versions/2/PosOrderActionsDetails.vue'
import DonationCampaignOrdersReport from 'src/components/Dashboard/Views/Reports/DonationCampaignOrdersReport.vue'
import RaffleCampaignParticipantsReport from 'src/components/Dashboard/Views/Reports/RaffleCampaignParticipantsReport.vue'
import LoyaltyStorePurchasesReport from 'src/components/Dashboard/Views/Reports/LoyaltyStorePurchasesReport.vue'
import ChallengeCampaignUsersReport from 'src/components/Dashboard/Views/Reports/ChallengeCampaignUsersReport.vue'
import ChallengeUserProgressLogsReport from 'src/components/Dashboard/Views/Reports/ChallengeUserProgressLogsReport.vue'
import SpinningWheelRewardsReport from 'src/components/Dashboard/Views/Reports/SpinningWheelRewardsReport.vue'
import SpinningWheelUsersReport from 'src/components/Dashboard/Views/Reports/SpinningWheelUsersReport.vue'
import CharismaLocationReceiptDetails from 'src/components/Dashboard/Views/Reports/Versions/2/CharismaLocationReceiptDetails.vue'
import ReferralProgramAmbassadorDrilldownModal from 'src/components/Dashboard/Views/Reports/Versions/2/ReferralProgramAmbassadorDrilldownModal.vue'

// Settings
// import Settings from 'src/components/Dashboard/Views/Settings/Settings.vue'
import SettingsSidebar from 'src/components/Dashboard/Views/Settings/SettingsSidebar.vue'
import SettingsGeneral from '../components/Dashboard/Views/Settings/SettingsGeneral.vue'
import SettingsLocations from 'src/components/Dashboard/Views/Settings/SettingsLocations.vue'
import SettingsModules from 'src/components/Dashboard/Views/Settings/SettingsModules.vue'
import Users from 'src/components/Dashboard/Views/Settings/Users/Users.vue'
import UserAdd from 'src/components/Dashboard/Views/Settings/Users/UserAdd.vue'
import UserEdit from 'src/components/Dashboard/Views/Settings/Users/UserEdit.vue'
import PrinterAdd from 'src/components/Dashboard/Views/Settings/Printer/PrinterAdd.vue'
import PrinterEdit from 'src/components/Dashboard/Views/Settings/Printer/PrinterEdit.vue'
import Feedback from 'src/components/Dashboard/Views/Settings/Feedback/Feedback.vue'
import FeedbackView from 'src/components/Dashboard/Views/Settings/Feedback/FeedbackView.vue'
import LocationGroups from 'src/components/Dashboard/Views/Settings/LocationGroups/LocationGroups.vue'
import LocationGroupsAdd from 'src/components/Dashboard/Views/Settings/LocationGroups/LocationGroupsAdd.vue'
import LocationGroupsEdit from 'src/components/Dashboard/Views/Settings/LocationGroups/LocationGroupsEdit.vue'

// New locations views
import LocationAdd from 'src/components/Dashboard/Views/Settings/Locations/LocationAdd.vue'
import LocationEdit from 'src/components/Dashboard/Views/Settings/Locations/LocationEdit.vue'
import LocationEditWolt from 'src/components/Dashboard/Views/Settings/Locations/LocationEditWolt.vue'
import PlatformMenuImports from 'src/components/Dashboard/Views/Integrations/PlatformMenuImports/PlatformMenuImports.vue'
import ProductImportList from 'src/components/Dashboard/Views/Settings/Locations/ProductImports/ProductImportList.vue'
import ProductImportDetail from 'src/components/Dashboard/Views/Settings/Locations/ProductImports/ProductImportDetail.vue'

// payment
import Payment from 'src/components/Dashboard/Views/Payment/Payment.vue'

// Payment Groups
import PaymentGroupsAdd from 'src/components/Dashboard/Views/Settings/PaymentGroups/PaymentGroupsAdd.vue'
import PaymentGroupsEdit from 'src/components/Dashboard/Views/Settings/PaymentGroups/PaymentGroupsEdit.vue'

// Newsletter
// import Newsletter from 'src/components/Dashboard/Views/Newsletter/Newsletter.vue'
import NewsletterSidebar from 'src/components/Dashboard/Views/Newsletter/NewsletterSidebar.vue'
import News from 'src/components/Dashboard/Views/Newsletter/Tabs/News.vue'
import MonthlyInfo from 'src/components/Dashboard/Views/Newsletter/Tabs/MonthlyInfo.vue'
import VideoSupport from 'src/components/Dashboard/Views/Newsletter/Tabs/VideoSupport.vue'

// Pages
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Recover from 'src/components/Dashboard/Views/Pages/Recover.vue'
import Reset from 'src/components/Dashboard/Views/Pages/Reset.vue'

// Wolt Callback
import WoltCallback from 'src/components/Dashboard/Views/Pages/Wolt.vue'

const loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

const registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

const recoverPage = {
  path: '/recover',
  name: 'Recover Password',
  component: Recover
}

const resetPage = {
  path: '/reset',
  name: 'Reset Password',
  component: Reset
}

const woltPage = {
  path: '/wolt/callback',
  name: 'wolt',
  component: WoltCallback
}

const orderingMenu = {
  path: '/ordering-management',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Ordering Management',
      component: OrderingManagement
    },
    {
      path: 'view',
      name: 'Customer Details Ordering',
      component: CustomerView
    }
  ]
}

const customersView = {
  path: '/customer',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Customers View',
      component: CustomersView
    }
    // {
    //   path: '/',
    //   name: 'Customers Sidebar',
    //   component: CustomersSidebar
    // }
  ]
}

const approvalsView = {
  path: '/approvals',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Approvals View',
      component: Approvals
    }
  ]
}

const customersMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/customers',
      name: 'Customers',
      component: Customers
    },
    {
      path: 'customers/view/:id',
      name: 'Customer Details',
      component: CustomerView,
      meta: { modal: true }
    }
  ]
}

const customersGroupsMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: 'groups',
      name: 'Groups',
      component: GroupsCustomer
    },
    {
      path: 'groups/:id',
      name: 'Groups View',
      component: GroupsCustomerView,
      meta: { modal: true }
    }
  ]
}

const screens = {
  path: '/kds',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'kds',
      component: ScreenView
    }
  ]
}

const orderScreenView = {
  path: '/screens',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Screens',
      component: OrderScreenView
    }
  ]
}

const orderScreenTabs = {
  path: '/screens/tabs',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Ods Screen Tabs',
      component: OrderScreenTabs
    }
  ]
}

const kdsSettings = {
  path: '/screens/kds/settings',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Kds Settings',
      component: KdsSettings
    }
  ]
}

const kdsReport = {
  path: '/screens/kds/report',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Kds Report',
      component: KdsReport
    }
  ]
}
const kdsSidebar = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/screens/kds',
      name: 'Kds',
      component: KdsSidebar
    },
    {
      path: '/screens/kds',
      name: 'Kds Index',
      component: Kds
    },
    {
      path: '/screens/kds/add',
      name: 'Kds Add',
      component: KdsAdd,
      meta: { modal: true }
    },
    {
      path: '/screens/kds/edit/:id',
      name: 'Kds Edit',
      component: KdsEdit,
      meta: { modal: true }
    }
  ]
}

const kdsUsers = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/screens/kds/users',
      name: 'Kds Users',
      component: KdsSettingsUsers
    },
    {
      path: '/screens/kds/users/add',
      name: 'Kds Users Add',
      component: KdsUserAdd,
      meta: { modal: true }
    },
    {
      path: '/screens/kds/users/:id',
      name: 'Kds Users Edit',
      component: KdsUserEdit,
      meta: { modal: true }
    }
  ]
}

const kdsSections = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/screens/sections',
      name: 'Kds Section Index',
      component: KdsSections
    },
    {
      path: '/screens/sections/add',
      name: 'Kds Section Add',
      component: KdsSectionAdd,
      meta: { modal: true }
    },
    {
      path: '/screens/sections/edit/:id',
      name: 'Kds Section Edit',
      component: KdsSectionEdit,
      meta: { modal: true }
    }
  ]
}

const management = {
  path: '/management',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Management',
      component: ManagementTabs
    }
  ]
}

const invoice = {
  path: '/invoice',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Invoice',
      component: InvoiceTabs
    }
  ]
}

const invoiceTabs = {
  path: '/invoice-tabs',
  component: DashboardLayout,
  children: [
    {
      path: 'sidebar',
      name: 'InvoiceSidebar',
      component: InvoiceSidebar
    },
    {
      path: 'dashboard',
      name: 'InvoiceDashboard',
      component: InvoiceDashboard
    },
    {
      path: 'invoice/add',
      name: 'AddInvoice',
      component: InvoiceAdd,
      meta: { modal: true }
    },
    {
      path: 'invoice/edit/:id',
      name: 'EditInvoice',
      component: InvoiceEdit,
      meta: { modal: true }
    },
    {
      path: 'invoice/storno/:id',
      name: 'StornoInvoice',
      component: InvoiceStorno,
      meta: { modal: true }
    },
    {
      path: 'proforma',
      name: 'Proforma',
      component: Proforma
    },
    {
      path: 'proforma/add',
      name: 'AddProforma',
      component: ProformaAdd,
      meta: { modal: true }
    },
    {
      path: 'proforma/:id',
      name: 'EditProforma',
      component: ProformaEdit,
      meta: { modal: true }
    },
    {
      path: 'reports',
      name: 'InvoiceReports',
      component: InvoiceReports
    },
    {
      path: 'settings',
      name: 'InvoiceSettings',
      component: InvoiceSettings
    }
  ]
}

const managementTabs = {
  path: '/management',
  component: DashboardLayout,
  children: [
    {
      path: 'sidebar',
      name: 'ManagementSidebar',
      component: ManagementSidebar
    },
    {
      path: 'outputsTabs',
      name: 'ManagementOutputsTabs',
      component: ManagementOutputsTabs
    },
    {
      path: 'entriesTabs',
      name: 'ManagementEntriesTabs',
      component: ManagementEntriesTabs
    },
    {
      path: 'stocksTabs',
      name: 'ManagementStocksTabs',
      component: ManagementStocksTabs
    },
    {
      path: 'production',
      name: 'ManagementProduction',
      component: ManagementProduction
    },
    {
      path: 'lot',
      name: 'ManagementLot',
      component: ManagementLot
    },
    {
      path: 'dashboard',
      name: 'ManagementDashboard',
      component: ManagementDashboard
    },
    {
      path: 'nomenclatorTabs',
      name: 'NomenclatorTabs',
      component: NomenclatorTabs
    },
    {
      path: 'management-clients',
      name: 'ManagementClients',
      component: ManagementClients
    },
    {
      path: 'nomenclator-products',
      name: 'NomenclatorProducts',
      component: NomenclatorProducts
    },
    {
      path: 'nomenclator-products/edit/:id/:vatNumber',
      name: 'NomenclatorProductsEdit',
      component: NomenclatorProductsEdit,
      meta: { modal: true }
    },
    {
      path: 'bon-product',
      name: 'ManagementBonProduct',
      component: ManagementBonProduct
    },
    {
      path: 'bon-product/add',
      name: 'AddManagementBonProduct',
      component: ManagementBonProductAdd,
      meta: { modal: true }
    },
    {
      path: 'bon-product/edit/:series/:number',
      name: 'ManagementBonProductEdit',
      component: ManagementBonProductEdit,
      meta: { modal: true }
    },
    {
      path: 'stocks',
      name: 'ManagementStocks',
      component: ManagementStocks
    },
    {
      path: 'stocks/add',
      name: 'AddManagementStocks',
      component: ManagementStocksAdd,
      meta: { modal: true }
    },
    {
      path: 'stocks/edit/:series/:number',
      name: 'ManagementStocksEdit',
      component: ManagementStocksEdit,
      meta: { modal: true }
    },
    {
      path: 'wasted',
      name: 'ManagementWasted',
      component: ManagementWasted
    },
    {
      path: 'wasted/add',
      name: 'AddManagementWasted',
      component: ManagementWastedAdd,
      meta: { modal: true }
    },
    {
      path: 'wasted/edit/:series/:number',
      name: 'ManagementWastedEdit',
      component: ManagementWastedEdit,
      meta: { modal: true }
    },
    {
      path: 'transfer',
      name: 'ManagementTransfer',
      component: ManagementTransfer
    },
    {
      path: 'transfer/add',
      name: 'AddManagementTransfer',
      component: ManagementTransferAdd,
      meta: { modal: true }
    },
    {
      path: 'transfer/edit/:series/:number',
      name: 'ManagementTransferEdit',
      component: ManagementTransferEdit,
      meta: { modal: true }
    },
    {
      path: 'entries',
      name: 'ManagementEntries',
      component: ManagementEntries
    },
    {
      path: 'entries/add',
      name: 'AddManagementEntries',
      component: ManagementEntriesAdd,
      meta: { modal: true }
    },
    {
      path: 'entries/edit/:id',
      name: 'ManagementEntriesEdit',
      component: ManagementEntriesEdit,
      meta: { modal: true }
    },
    {
      path: 'invoice-supplier',
      name: 'ManagementInvoiceSupplier',
      component: ManagementInvoiceSupplier
    },
    {
      path: 'view-invoice-supplier/:id',
      name: 'ManagementInvoiceSupplierView',
      component: ManagementInvoiceSupplierView,
      meta: { modal: true }
    },
    {
      path: 'outputs',
      name: 'ManagementAviz',
      component: ManagementAviz
    },
    {
      path: 'outputs/:id',
      name: 'ManagementAvizEdit',
      component: ManagementAvizEdit,
      meta: { modal: true }
    },
    {
      path: 'outputs/add/:orderData?',
      name: 'AddManagementAviz',
      component: ManagementAvizAdd,
      meta: { modal: true }
    },
    {
      path: 'outputs',
      name: 'ManagementBonFiscal',
      component: ManagementBonFiscal
    },
    {
      path: 'outputs/view/:id',
      name: 'ManagementBonFiscalView',
      component: ManagementBonFiscalView,
      meta: { modal: true }
    },
    {
      path: 'inventory',
      name: 'ManagementInventory',
      component: ManagementInventory
    },
    {
      path: 'inventory/add',
      name: 'AddInventory',
      component: ManagementInventoryAdd,
      meta: { modal: true }
    },
    {
      path: 'inventory/edit/:vatNumber/:series/:number/:externalLocationId',
      name: 'EditInventory',
      component: ManagementInventoryEdit,
      meta: { modal: true }
    },
    {
      path: 'initialStock',
      name: 'ManagementInitialStock',
      component: ManagementInitialStock
    },
    {
      path: 'initialStock/add',
      name: 'AddInitialStock',
      component: ManagementInitialStockAdd,
      meta: { modal: true }
    },
    {
      path: 'initialStock/edit/:id/',
      name: 'EditInitialStock',
      component: ManagementInitialStockEdit,
      meta: { modal: true }
    },
    {
      path: 'suppliers-tabs',
      name: 'ManagementSuppliersTabs',
      component: ManagementSuppliersTabs
    },
    {
      path: 'suppliers',
      name: 'ManagementSuppliers',
      component: ManagementSuppliers
    },
    {
      path: 'orders-suppliers',
      name: 'ManagementOrdersSuppliers',
      component: ManagementOrdersSuppliers
    },
    {
      path: 'my-orders-suppliers',
      name: 'ManagementMyOrdersSuppliers',
      component: ManagementMyOrdersSuppliers
    },
    {
      path: 'my-orders-suppliers/add',
      name: 'AddManagementMyOrdersSuppliers',
      component: ManagementMyOrdersSuppliersAdd,
      meta: { modal: true }
    },
    {
      path: 'my-orders-suppliers/edit/:id',
      name: 'EditManagementMyOrdersSuppliers',
      component: ManagementMyOrdersSuppliersEdit,
      meta: { modal: true }
    },
    {
      path: 'for-orders-suppliers/add',
      name: 'AddManagementForOrdersSuppliers',
      component: ManagementForOrdersSuppliersAdd,
      meta: { modal: true }
    },
    {
      path: 'for-orders-suppliers',
      name: 'ManagementForOrdersSuppliers',
      component: ManagementForOrdersSuppliers
    },
    {
      path: 'for-orders-suppliers/edit/:id',
      name: 'EditManagementForOrdersSuppliers',
      component: ManagementForOrdersSuppliersEdit,
      meta: { modal: true }
    },
    {
      path: 'accounting-sales',
      name: 'AccountingSales',
      component: AccountingSales
    },
    {
      path: 'accounting-inbound-invoices',
      name: 'AccountingSales',
      component: AccountingInboundInvoices
    },
    {
      path: 'casa-register',
      name: 'ManagementCasaRegister',
      component: ManagementCasaRegister
    },
    {
      path: 'settings-users',
      name: 'ManagementUsers',
      component: ManagementUsers
    },
    {
      path: 'reports',
      name: 'ManagementReports',
      component: ManagementReports
    },
    {
      path: 'settings',
      name: 'ManagementSettings',
      component: ManagementSettings
    }
  ]
}

const orderScreen = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/ods/order-screen',
      name: 'Order Screen',
      component: OrderScreen
    },
    {
      path: '/ods/order-screen/add',
      name: 'Add Order Screen',
      component: OrderScreenAdd,
      meta: { modal: true }
    },
    {
      path: '/ods/order-screen/edit/:id',
      name: 'Edit Order Screen',
      component: OrderScreenEdit,
      meta: { modal: true }
    },
    {
      path: '/pos/screen/add',
      name: 'Add Screen',
      component: PosScreenAdd,
      meta: { modal: true }
    },
    {
      path: '/pos/screen/edit/:id',
      name: 'Edit Screen',
      component: PosScreenEdit,
      meta: { modal: true }
    },
    {
      path: '/digital/signage/add',
      name: 'Digital Order Screen Add',
      component: DigitalSignageAdd,
      meta: { modal: true }
    },
    {
      path: '/digital/signage/edit/:id',
      name: 'Digital Order Screen Edit',
      component: DigitalSignageEdit,
      meta: { modal: true }
    }
  ]
}

const catalogView = {
  path: '/catalog',
  component: DashboardLayout,
  children: [
    // {
    //   path: '/',
    //   name: 'Catalog',
    //   component: CatalogView
    // },
    {
      path: '/',
      name: 'Catalog',
      component: CatalogSidebar
    }
  ]
}

const InfoPage = {
  path: '/info-pages',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Info Pages',
      component: InfoPages
    }
  ]
}


const infoPagesCustom = {
  path: '/custom-info-pages',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Pages Info Custom',
      component: CustomInfoPages
    },
    {
      path: '/custom-info-pages/add',
      name: 'Add Page Info Custom',
      component: CustomInfoPageAdd,
      meta: { modal: true }
    },
    {
      path: '/custom-info-pages/edit/:id',
      name: 'Edit Page Info Custom',
      component: CustomInfoPageEdit,
      meta: { modal: true }
    }
  ]
}


const GiftCardFormRoute = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/gift-cards/:id',
      name: 'GiftCardForm',
      component: GiftCardForm,
      meta: { modal: true }
    }
  ]
}

const ordersPos = {
  path: '/add-order',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Orders',
      component: OrdersPos
    },
    {
      path: '/add-order/:id',
      name: 'Order Details',
      component: OrdersPosView
    }
  ]
}

const ordersPosClientScreen = {
  path: '/order-pos-client-screen',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Order Pos Client Screen',
      component: OrderPosClientScreen
    }
  ]
}

const scanner = {
  path: '/scanner',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Scanner',
      component: Scanner
    }
  ]
}

const online = {
  path: '/online',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Online',
      component: Online
    }
  ]
}

const kiosk = {
  path: '/kiosk',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Kiosk',
      component: Kiosk
    }
  ]
}

const qr = {
  path: '/qr',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Qr',
      component: Qr
    }
  ]
}

const dispatch = {
  path: '/dispatch',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Dispatch',
      component: Dispatch
    }
  ]
}

const dispatchTabs = {
  path: '/dispatch-view',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Dispatch Tabs',
      component: DispatchTabs
    }
  ]
}


const dispatchOrders = {
  path: '/dispatch',
  component: DashboardLayout,
  children: [
    {
      path: '/dispach-orders',
      name: 'Dispatch Orders',
      component: DispatchOrders
    },
    {
      path: '/dispach-drivers',
      name: 'Dispatch Drivers',
      component: DispatchDrivers
    },
    {
      path: '/dispach-reports',
      name: 'Dispatch Reports',
      component: DispatchReports
    },
    {
      path: '/dispach-settings',
      name: 'Dispatch Settings',
      component: DispatchSettings
    }
  ]
}

const posSettings = {
  path: '/pos',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Pos Index',
      component: PosSettingsView
    },
    {
      path: '/pos/list',
      name: 'Pos List',
      component: PosSettingsList
    },
    {
      path: '/pos/add',
      name: 'Pos Add',
      component: PosSettingsAdd,
      meta: { modal: true }
    },
    {
      path: '/pos/edit/:id',
      name: 'Pos Edit',
      component: PosSettingsEdit,
      meta: { modal: true }
    },
    {
      path: '/pos/users',
      name: 'Pos Users',
      component: PosSettingsUsers
    },
    {
      path: '/pos/users/add',
      name: 'Pos Users Add',
      component: PosUserAdd,
      meta: { modal: true }
    },
    {
      path: '/pos/users/:id',
      name: 'Pos Users Edit',
      component: PosUserEdit,
      meta: { modal: true }
    },
    {
      path: '/pos/map/add',
      name: 'Pos Map Add',
      component: PosMapAdd,
      meta: { modal: true }
    },
    {
      path: '/pos/map/:id',
      name: 'Pos Map Edit',
      component: PosMapEdit,
      meta: { modal: true }
    },
    {
      path: '/pos/settings',
      name: 'Pos Settings',
      component: PosSettingsSettings
    },
    {
      path: '/pos/reports',
      name: 'Pos Reports',
      component: PosSettingsReports
    },
    {
      path: '/fiscal-printer/add',
      name: 'Fiscal Printer Add',
      component: FiscalPrinterAdd,
      meta: { modal: true }
    },
    {
      path: '/fiscal-printer/edit/:id',
      name: 'Fiscal Printer Edit',
      component: FiscalPrinterEdit,
      meta: { modal: true }
    },
    {
      path: '/cantar/add',
      name: 'Cantar Add',
      component: CantarAdd,
      meta: { modal: true }
    },
    {
      path: '/cantar/edit/:id',
      name: 'Cantar Edit',
      component: CantarEdit,
      meta: { modal: true }
    }
  ]
}

const posSettings2 = {
  path: '/pos',
  component: DashboardLayout,
  children: [
    {
      path: '/pos/tabs',
      name: 'Pos tabs',
      component: PosSettingsTabs
    }
  ]
}

const reservations = {
  path: '/reservations',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Reservations',
      component: Reservations,
      session: 'newReservations'
    }
  ]
}

const tables = {
  path: '/tables',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Tables',
      component: Tables,
      session: 'newTables'
    }
  ]
}

const ordersMenu = {
  path: '/orders',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Orders Menu',
      component: Orders,
      session: 'newOrders'
    },
    {
      path: 'view/:id',
      name: 'Order Details Menu',
      component: OrderView,
      meta: { modal: true }
    },
    {
      path: 'edit/:id',
      name: 'Edit Order',
      component: OrderEdit
    }
  ]
}

const integrationPlatformMenuImports = {
  path: '/integrations',
  component: DashboardLayout,
  children: [
    {
      path: '/integrations/platform-menu-imports/:locationId/:importId?',
      name: 'Platform Menu Imports',
      component: PlatformMenuImports,
      meta: { modal: true }
    }
  ]
}

const integrationMenuFix = {
  path: '/integrations/menu-fix',
  component: DashboardLayout,
  children: [
    {
      path: '/integrations/menu-fix/product/:id',
      name: 'Integration Menu Fix Product',
      component: IntegrationMenuEntityEditPage,
      meta: { entityType: 'product' }
    },
    {
      path: '/integrations/menu-fix/product-option/:id',
      name: 'Integration Menu Fix Product Option',
      component: IntegrationMenuEntityEditPage,
      meta: { entityType: 'product-option' }
    },
    {
      path: '/integrations/menu-fix/group-option/:id',
      name: 'Integration Menu Fix Group Option',
      component: IntegrationMenuEntityEditPage,
      meta: { entityType: 'group-option' }
    }
  ]
}

const productsMenu = {
  path: '/products',
  component: DashboardLayout,
  children: [
    {
      path: '/products',
      name: 'Products',
      component: ProductsList
    },
    {
      path: '/products/add',
      name: 'Add Product',
      component: ProductAdd,
      meta: { modal: true }
    },
    {
      path: '/products/edit/:id',
      name: 'Edit Product',
      component: ProductEdit,
      meta: { modal: true }
    }
  ]
}

const priceListMenu = {
  path: '/price-profile',
  component: DashboardLayout,
  children: [
    {
      path: '/price-profile',
      name: 'Products',
      component: PriceProfile
    },
    {
      path: '/price-profile/add',
      name: 'Add Price Profile',
      component: PriceProfileAdd,
      meta: { modal: true }
    },
    {
      path: '/price-profile/edit/:id',
      name: 'Edit Price Profile',
      component: PriceProfileEdit,
      meta: { modal: true }
    }
  ]
}

const prodOptionsMenu = {
  path: '/product-options2',
  component: DashboardLayout,
  children: [
    {
      path: '/product-options2',
      name: 'Product Options Menu',
      component: ProductOptions
    }
  ]
}

const prodOptions = {
  path: '/product-options',
  component: DashboardLayout,
  children: [
    {
      path: '/product-options',
      name: 'Product Options',
      component: ProductOptions2
    },
    {
      path: '/product-option/add',
      name: 'Add Product Option',
      component: ProductOptionAdd,
      meta: { modal: true }
    },
    {
      path: '/product-option/edit/:id',
      name: 'Edit Product Option',
      component: ProductOptionEdit,
      meta: { modal: true }
    }
  ]
}

const groupOptionsMenu = {
  path: '/group-options',
  component: DashboardLayout,
  children: [
    {
      path: '/group-options',
      name: 'Group Options',
      component: GroupOptions
    },
    {
      path: '/group-option/add',
      name: 'Add Group Option',
      component: GroupOptionsAdd,
      meta: { modal: true }
    },
    {
      path: '/group-option/edit/:id',
      name: 'Edit Group Option',
      component: GroupOptionsEdit,
      meta: { modal: true }
    }
  ]
}

const prodFiltersMenu = {
  path: '/product-filters',
  component: DashboardLayout,
  children: [
    {
      path: '/product-filters',
      name: 'Product Filters',
      component: ProductFilters
    }
  ]
}

const linksMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/menu-links',
      name: 'Menu Links',
      component: MenuLinks
    },
    {
      path: '/menu-links/add',
      name: 'Add Menu Link',
      component: MenuLinkAdd,
      meta: { modal: true }
    },
    {
      path: '/menu-links/edit/:id',
      name: 'Edit Menu Link',
      component: MenuLinkEdit,
      meta: { modal: true }
    }
  ]
}

const categoriesMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/categories',
      name: 'Categories',
      component: Categories
    },
    {
      path: '/categories/add',
      name: 'Add Category',
      component: CategoryAdd,
      meta: { modal: true }
    },
    {
      path: '/categories/edit/:id',
      name: 'Edit Category',
      component: CategoryEdit,
      meta: { modal: true }
    }
  ]
}

const topCategoriesMenu = {
  path: '/top-categories',
  component: DashboardLayout,
  children: [
    {
      path: '/top-categories',
      name: 'TopCategories',
      component: TopCategories
    },
    {
      path: '/top-categories/add',
      name: 'Add Top Category',
      component: TopCategoryAdd,
      meta: { modal: true }
    },
    {
      path: '/top-categories/edit/:id',
      name: 'Edit Top Category',
      component: TopCategoryEdit,
      meta: { modal: true }
    }
  ]
}

const marketingMenu = {
  path: '/marketing',
  component: DashboardLayout,
  children: [
    {
      path: 'campaigns',
      name: 'Campaigns',
      component: Campaigns
    },
    {
      path: 'campaigns/add',
      name: 'Add Campaign',
      component: CampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'campaigns/edit/:id',
      name: 'Edit Campaign',
      component: CampaignEdit,
      meta: { modal: true }
    },
    {
      path: 'coupons/add',
      name: 'Add Coupon',
      component: CouponPage,
      meta: { modal: true }
    },
    {
      path: 'coupons/edit/:id',
      name: 'Edit Coupon',
      component: CouponPage,
      meta: { modal: true }
    },
    {
      path: 'subscriptions/add',
      name: 'Add Subscription',
      component: SubscriptionPage,
      meta: { modal: true }
    },
    {
      path: 'subscriptions/edit/:id',
      name: 'Edit Subscription',
      component: SubscriptionPage,
      meta: { modal: true }
    },
    {
      path: 'subscriptions/subscribers',
      name: 'Subscription Subscribers',
      component: SubscribersPage,
      meta: { modal: true }
    },
    {
      path: 'automation/add',
      name: 'Add Automation Campaign',
      component: AutomationCampaignPage,
      meta: { modal: true }
    },
    {
      path: 'automation/edit/:id',
      name: 'Edit Automation Campaign',
      component: AutomationCampaignPage,
      meta: { modal: true }
    },
    {
      path: 'automation/beneficiaries',
      name: 'Automation Campaign Beneficiaries',
      component: AutomationBeneficiariesPage,
      meta: { modal: true }
    },
    {
      path: 'donation-campaigns',
      name: 'Donation Campaigns',
      component: DonationCampaigns
    },
    {
      path: 'donation-campaigns/add',
      name: 'Add Donation Campaign',
      component: DonationCampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'donation-campaigns/edit/:id',
      name: 'Edit Donation Campaign',
      component: DonationCampaignEdit,
      meta: { modal: true }
    },
    {
      path: 'menu-subscriptions/add',
      name: 'Add Menu Subscription',
      component: MenuSubscriptionPage,
      meta: { modal: true }
    },
    {
      path: 'menu-subscriptions/edit/:id',
      name: 'Edit Menu Subscription',
      component: MenuSubscriptionPage,
      meta: { modal: true }
    },
    {
      path: 'menu-subscriptions/subscribers',
      name: 'Menu Subscription Subscribers',
      component: MenuSubscribersPage,
      meta: { modal: true }
    },
    {
      path: 'discount-campaigns',
      name: 'Discount Campaigns',
      component: DiscountCampaigns
    },
    {
      path: 'discount-campaigns/add',
      name: 'Add Discount Campaign',
      component: DiscountCampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'discount-campaigns/edit/:id',
      name: 'Edit Discount Campaign',
      component: DiscountCampaignEdit,
      meta: { modal: true }
    },
    {
      path: 'challenge-campaigns',
      name: 'Challenge Campaigns',
      component: ChallengeCampaigns
    },
    {
      path: 'challenge-campaigns/add',
      name: 'Add Challenge Campaign',
      component: ChallengeCampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'challenge-campaigns/edit/:id',
      name: 'Edit Challenge Campaign',
      component: ChallengeCampaignEdit,
      meta: { modal: true }
    },
    {
      path: 'spinning-wheel-campaigns',
      name: 'Spinning Wheel Campaigns',
      component: SpinningWheelCampaigns
    },
    {
      path: 'spinning-wheel-campaigns/add',
      name: 'Add Spinning Wheel Campaign',
      component: SpinningWheelCampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'spinning-wheel-campaigns/edit/:id',
      name: 'Edit Spinning Wheel Campaign',
      component: SpinningWheelCampaignEdit,
      meta: { modal: true }
    },
    {
      path: 'offers',
      name: 'Offers Slider',
      component: Offers
    },
    {
      path: 'offers/add',
      name: 'Add Offer Slider',
      component: OffersAdd,
      meta: { modal: true }
    },
    {
      path: 'offers/edit/:id',
      name: 'Edit Offer Slider',
      component: OffersEdit,
      meta: { modal: true }
    },
    {
      path: 'offers/:offer_id/add-group-banner',
      name: 'Add Offer Group',
      component: OffersGroupAdd,
      meta: { modal: true }
    },
    {
      path: 'offers/:offer_id/edit-group-banner/:id',
      name: 'Edit Offer Group',
      component: OffersGroupEdit,
      meta: { modal: true }
    },
    {
      path: 'dynamic-menus',
      name: 'menus',
      component: DynamicMenu
    }
  ]
}


const marketingView = {
  path: '/marketing',
  component: DashboardLayout,
  children: [
    // {
    //   path: '/',
    //   name: 'Marketing',
    //   component: MarketingView
    // },
    {
      path: '/',
      name: 'Marketing',
      component: MarketingSidebar
    },
    {
      path: 'promos',
      name: 'Promos',
      component: Promos
    },
    {
      path: 'promos/add',
      name: 'Add Promo',
      component: PromosAdd,
      meta: { modal: true }
    },
    {
      path: 'promos/edit/:id',
      name: 'Edit Promo',
      component: PromosEdit,
      meta: { modal: true }
    },
    {
      path: 'referral-campaigns/add',
      name: 'Add Referral Campaign',
      component: ReferralCampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'referral-campaigns/edit/:id',
      name: 'Edit Referral Campaign',
      component: ReferralCampaignEdit,
      meta: { modal: true }
    },
    {
      path: 'raffle-campaigns/add',
      name: 'Add Raffle Campaign',
      component: RaffleCampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'raffle-campaigns/edit/:id',
      name: 'Edit Raffle Campaign',
      component: RaffleCampaignEdit,
      meta: { modal: true }
    },
    {
      path: 'loyalty-store-campaigns/add',
      name: 'Add Loyalty Store Campaign',
      component: LoyaltyStoreCampaignAdd,
      meta: { modal: true }
    },
    {
      path: 'loyalty-store-campaigns/edit/:id',
      name: 'Edit Loyalty Store Campaign',
      component: LoyaltyStoreCampaignEdit,
      meta: { modal: true }
    }
  ]
}

const marketingMenuNoSpacing = {
  path: '/marketing',
  component: DashboardLayout,
  children: [
    {
      path: 'fidelities',
      name: 'Fidelities',
      component: Fidelities
    },
    {
      path: '/user-label',
      name: 'User Label',
      component: UserLabeling
    },
    {
      path: '/user-label/add',
      name: 'Add User Label',
      component: UserLabelingAdd,
      meta: { modal: true }
    },
    {
      path: '/user-label/edit/:id',
      name: 'Edit User Label',
      component: UserLabelingEdit,
      meta: { modal: true }
    }
  ]
}

const rewardMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/reward-program',
      name: 'Edit Reward Program',
      component: RewardProgramEdit
    }
  ]
}

const reportsMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/reports',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/reports/referral-program/ambassador/:ambassadorId',
      name: 'Referral Program Ambassador Drilldown',
      component: ReferralProgramAmbassadorDrilldownModal,
      meta: { modal: true }
    },
    {
      path: '/reports/customer/:id',
      name: 'Customer Details Reports',
      component: ReportsCustomerDetails
    },
    {
      path: '/reports/charisma/items/:orderId',
      name: 'Charisma Items',
      component: CharismaItems,
      meta: { modal: true }
    },
    {
      path: '/reports/charisma/location-receipts/:locationId',
      name: 'Charisma Location Receipt Details',
      component: CharismaLocationReceiptDetails
    },
    {
      path: '/reports/nexus/items/:orderId',
      name: 'Nexus Items',
      component: NexusItems,
      meta: { modal: true }
    },
    {
      path: '/reports/pos-order-actions/:orderId',
      name: 'POS Order Actions Details',
      component: PosOrderActionsDetails,
      meta: { modal: true }
    },
    {
      path: '/reports/donation-campaigns/:campaignId/orders',
      name: 'Donation Campaign Orders Report',
      component: DonationCampaignOrdersReport,
      meta: { modal: true }
    },
    {
      path: '/reports/raffle-campaigns/:campaignId/participants',
      name: 'Raffle Campaign Participants Report',
      component: RaffleCampaignParticipantsReport,
      meta: { modal: true }
    },
    {
      path: '/reports/loyalty-store/rewards/:rewardId/purchases',
      name: 'Loyalty Store Purchases Report',
      component: LoyaltyStorePurchasesReport,
      meta: { modal: true }
    },
    {
      path: '/reports/challenge-campaigns/:challengeId/users',
      name: 'Challenge Campaign Users Report',
      component: ChallengeCampaignUsersReport,
      meta: { modal: true }
    },
    {
      path: '/reports/challenge-campaigns/:challengeId/users/:userId/logs',
      name: 'Challenge User Progress Logs Report',
      component: ChallengeUserProgressLogsReport,
      meta: { modal: true }
    },
    {
      path: '/reports/spinning-wheel/rewards/:rewardId/users',
      name: 'Spinning Wheel Users Report',
      component: SpinningWheelUsersReport,
      meta: { modal: true }
    },
    {
      path: '/reports/spinning-wheel/:campaignId/rewards',
      name: 'Spinning Wheel Rewards Report',
      component: SpinningWheelRewardsReport,
      meta: { modal: true }
    }
  ]
}

const settingsMenu = {
  path: '/settings',
  component: DashboardLayout,
  children: [
    // {
    //   path: '/',
    //   name: 'Settings',
    //   component: Settings
    // },
    {
      path: '/',
      name: 'Sidebar Settings',
      component: SettingsSidebar
    },
    {
      path: '/settings/general',
      name: 'General Settings',
      component: SettingsGeneral
    },
    {
      path: '/settings/locations',
      name: 'Location Settings',
      component: SettingsLocations
    },
    {
      path: '/settings/modules',
      name: 'Module Manager',
      component: SettingsModules
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    },
    {
      path: '/user/add',
      name: 'Add User',
      component: UserAdd,
      meta: { modal: true }
    },
    {
      path: '/user/edit/:id',
      name: 'Edit User',
      component: UserEdit,
      meta: { modal: true }
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: Feedback,
      session: 'newFeedback'
    },
    {
      path: '/feedback/view/:id',
      name: 'View Feedback',
      component: FeedbackView
    },
    {
      path: '/printer/add',
      name: 'Add Printer',
      component: PrinterAdd,
      meta: { modal: true }
    },
    {
      path: '/printer/edit/:id',
      name: 'Edit Printer',
      component: PrinterEdit,
      meta: { modal: true }
    },
    {
      path: '/payment-groups/add',
      name: 'Add Payment Groups',
      component: PaymentGroupsAdd,
      meta: { modal: true }
    },
    {
      path: '/payment-groups/edit/:id',
      name: 'Edit Payment Groups',
      component: PaymentGroupsEdit,
      meta: { modal: true }
    },
    {
      path: '/location-groups',
      name: 'Location Groups',
      component: LocationGroups
    },
    {
      path: '/location-groups/add',
      name: 'Add Location Groups',
      component: LocationGroupsAdd
    },
    {
      path: '/location-groups/edit/:id',
      name: 'Edit Location Groups',
      component: LocationGroupsEdit
    },
    {
      path: '/locations/add',
      name: 'Add New Location',
      component: LocationAdd,
      meta: { modal: true }
    },
    {
      path: '/locations/edit/:id',
      name: 'Edit Location',
      component: LocationEdit,
      meta: { modal: true }
    },
    {
      path: '/locations/edit-wolt/:id',
      name: 'Edit Location Wolt',
      component: LocationEditWolt
    },
    {
      path: '/locations/:locationId/product-imports',
      name: 'Product Import History',
      component: ProductImportList,
      meta: { modal: true }
    },
    {
      path: '/locations/:locationId/product-imports/:importId',
      name: 'Product Import Detail',
      component: ProductImportDetail,
      meta: { modal: true }
    }
  ]
}

const feedbackMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/feedback',
      name: 'Feedback Menu',
      component: Feedback,
      session: 'newFeedback'
    },
    {
      path: '/feedback/view/:id',
      name: 'View Feedback Menu',
      component: FeedbackView
    }
  ]
}

const adminOverviewNoSpacing = {
  path: '/',
  component: DashboardLayout,
  redirect: '/admin/overview',
  children: []
}

const adminOverview = {
  path: '/admin',
  component: DashboardLayout,
  redirect: '/admin/overview',
  children: [
    {
      path: 'overview',
      name: 'Overview',
      component: Overview
    },
    {
      path: 'stats',
      name: 'Stats',
      component: Stats
    }
  ]
}

const notFound = {
  path: '*',
  component: NotFound
}

const payment = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/payment',
      name: 'Payment',
      component: Payment
    }
  ]
}

const newsletter = {
  path: '/',
  component: DashboardLayout,
  children: [
    // {
    //   path: '/newsletter',
    //   name: 'Newsletter',
    //   component: Newsletter
    // },
    {
      path: '/newsletter',
      name: 'Newsletter Sidebar',
      component: NewsletterSidebar
    },
    {
      path: '/newsletter/news',
      name: 'News',
      component: News
    },
    {
      path: '/newsletter/monthly-info',
      name: 'MonthlyInfo',
      component: MonthlyInfo
    },
    {
      path: '/newsletter/video-support',
      name: 'VideoSupport',
      component: VideoSupport
    }
  ]
}

const routes = [
  adminOverviewNoSpacing,
  orderingMenu,
  customersMenu,
  customersGroupsMenu,
  screens,
  orderScreenView,
  kdsSidebar,
  kdsUsers,
  kdsSections,
  kdsSettings,
  orderScreenTabs,
  kdsReport,
  orderScreen,
  feedbackMenu,
  InfoPage,
  ordersPos,
  ordersPosClientScreen,
  online,
  kiosk,
  qr,
  dispatch,
  dispatchOrders,
  marketingView,
  customersView,
  approvalsView,
  catalogView,
  dispatchTabs,
  scanner,
  ordersMenu,
  reservations,
  tables,
  productsMenu,
  priceListMenu,
  prodOptionsMenu,
  prodOptions,
  groupOptionsMenu,
  integrationMenuFix,
  integrationPlatformMenuImports,
  prodFiltersMenu,
  categoriesMenu,
  marketingMenu,
  linksMenu,
  marketingMenuNoSpacing,
  rewardMenu,
  infoPagesCustom,
  GiftCardFormRoute,
  reportsMenu,
  settingsMenu,
  topCategoriesMenu,
  loginPage,
  registerPage,
  recoverPage,
  resetPage,
  woltPage,
  adminOverview,
  payment,
  newsletter,
  notFound,
  management,
  managementTabs,
  invoiceTabs,
  invoice,
  posSettings,
  posSettings2
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js